import { createContext, useContext } from 'react';

export const ComponentContext = createContext({
    activeComponent: 'Devices',
    setActiveComponent: () => {},
});

export const useComponentContext = () => useContext(ComponentContext);